module.exports = __webpack_public_path__ + "img/Group.9aed4a85.svg";